import { render } from "./DashboardPage_KAVALAN.vue?vue&type=template&id=c50206de&scoped=true"
import script from "./DashboardPage_KAVALAN.vue?vue&type=script&lang=js"
export * from "./DashboardPage_KAVALAN.vue?vue&type=script&lang=js"

import "./DashboardPage_KAVALAN.vue?vue&type=style&index=0&id=c50206de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c50206de"]])

export default __exports__